<template>
  <div>
    <el-form
      class="form"
      label-position="top"
      :model="form1"
      :rules="rules"
      ref="form1"
      label-width="80px"
    >
      <!--
      <el-form-item label="标题一" required>
        <el-input v-model="form1.teacher_title_one" maxlength="30" show-word-limit></el-input>
      </el-form-item>
-->
      <el-form-item label="标题" required>
        <el-input
          v-model="form1.teacher_title_two"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-card shadow="nerver">
          <el-button type="primary" @click="addTeacher" size="mini"
            >添加老师</el-button
          >
          <div class="classTable">
            <el-table
              row-key="id"
              :show-header="false"
              class="addcourses"
              :data="tableData"
              :header-cell-style="{ background: '#f5f7fa' }"
              ref="sortableTable"
            >
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="desc" label="简介"></el-table-column>

              <el-table-column prop="id" label="照片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.img_url"
                    fit="cover"
                  ></el-image>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="updateTeacher(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    @click="deleteTeacher(scope.row)"
                    >删除</el-button
                  >
                  <el-button size="small" type="text">
                    <i class="el-icon-rank"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form-item>

      <el-form-item label="是否显示">
        <el-card shadow="never">
          <el-switch
            v-model="form1.teacher_is_show"
            active-text="开启"
            inactive-text="关闭"
          >
          </el-switch>
        </el-card>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('form1')" size="small"
          >保存</el-button
        >
        <el-button @click="resetHomepage('7')" size="small">重置</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="添加老师1" :visible.sync="dialogVisible" width="600px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules">
        <el-form-item label="姓名" required prop="name">
          <el-input
            placeholder="请输入姓名"
            v-model="form.name"
            style="width: 480px"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="简介" required prop="desc">
          <el-input
            placeholder="请输入简介"
            v-model="form.desc"
            style="width: 480px"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="选择照片" required prop="fileList">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="form.fileList"
            list-type="picture"
            style="width: 400px"
          >
            <el-button size="mini" type="primary" plain
              >点击上传<i class="el-icon-upload el-icon--right"></i
            ></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="margin-left: 10px">推荐尺寸: 800px * 800px</span>
              <span style="margin-left: 10px">
                只能上传jpg/png文件，且不超过500kb</span
              >
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('form')" size="small"
          >保 存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadTeacher,
  updateTeacher,
  deleteTeacher,
  updateHomepage,
  resetHomepage,
  updateHomepageTeacherSortNum,
} from '@/api/homeset'
import uploadFile from '@/config/uploadFile'
import Sortable from 'sortablejs'

export default {
  name: 'teachers',
  props: {
    homepageTeacher: Array,
    homepage_id: Number,
    teacher_title_one: String,
    teacher_title_two: String,
    teacher_is_show: Boolean,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }

    return {
      imageId: '',
      //添加和修改
      form: {
        name: '',
        desc: '',
        fileList: [],
      },
      form1: {
        teacher_title_one: '',
        teacher_title_two: '',
        teacher_is_show: true,
      },
      tableData: [],
      dialogVisible: false,
      uploadFileTime: false,

      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],

        desc: [
          { required: true, message: '请输入简介', trigger: 'blur' },
          { required: true, message: '请输入简介', trigger: 'change' },
        ],

        fileList: [{ validator: validatePass, trigger: 'change' }],
      },
    }
  },

  watch: {
    teacher_is_show() {
      this.form1.teacher_is_show = this.teacher_is_show
    },
    homepageTeacher() {
      this.tableData = this.homepageTeacher
    },
    teacher_title_one() {
      this.form1.teacher_title_one = this.teacher_title_one
    },
    teacher_title_two() {
      this.form1.teacher_title_two = this.teacher_title_two
    },
  },
  mounted() {
    this.rowDrop()
  },
  methods: {
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(
        '.classTable .el-table__body-wrapper tbody'
      )
      const that = this
      console.log(that.tableData, 4547878)
      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: 'ghostClass', //设置拖拽停靠样式类名
        chosenClass: 'chosenClass', //设置选中样式类名
        handle: '.el-icon-rank',
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log('拖动了行，当前序号：' + newIndex)
          const currentRow = that.tableData.splice(oldIndex, 1)[0]
          that.tableData.splice(newIndex, 0, currentRow)
          console.log(that.tableData, 123456)
          let tchArr = []
          let homepage_id1 = that.tableData[0].homepage_id
          that.tableData.map((item, index) => {
            tchArr.push({
              id: item.id,
              sort_num: index,
            })
          })
          console.log(tchArr, 123456)
          updateHomepageTeacherSortNum({
            homepage_id: homepage_id1,
            tchArr: JSON.stringify(tchArr),
          }).then((res) => {
            console.log(res.allTchList, 1234156)
            that.tableData = res.allTchList
            that.$message.success('保存成功')
          })
        },
      })
    },
    addTeacher() {
      this.imageId = ''
      this.form.name = ''
      this.form.desc = ''
      this.form.fileList = []
      this.dialogVisible = true
    },

    updateTeacher(row) {
      this.imageId = row.id
      this.form.name = row.name
      this.form.desc = row.desc
      this.form.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
      this.dialogVisible = true
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imageId) {
            updateTeacher({
              id: this.imageId,
              name: this.form.name,
              desc: this.form.desc,
              img_url: this.form.fileList[0].url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('修改成功!')
                this.dialogVisible = false
                this.tableData = this.tableData.map((item) =>
                  item.id === res.result.id ? res.result : item
                )
              }
            })
          } else {
            console.log('添加教师')
            console.log(this.form.name)
            console.log(this.form.desc)
            console.log(this.homepage_id)
            console.log(this.form.fileList)

            uploadTeacher({
              name: this.form.name,
              desc: this.form.desc,
              img_url: this.form.fileList[0].url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_create) {
                this.$message.success('添加成功!')
                this.dialogVisible = false
                this.tableData.push(res.result)
              }
            })
          }
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateHomepage({
            id: this.homepage_id,
            teacher_title_one: this.form1.teacher_title_one,
            teacher_title_two: this.form1.teacher_title_two,
            teacher_is_show: this.form1.teacher_is_show === false ? '0' : '1',
          }).then((res) => {
            if (res.is_update) {
              this.$message.success('保存成功！')
            }
          })
        }
      })
    },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },

    uploadFile() {},

    async handleChangeFile(file, fileList) {
      if (file.size > 1024 * 500) {
        // 500kb
        this.form.fileList.pop()
        return this.$message.warning('图片不符合规则，请重新上传！')
      } else {
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res
          this.uploadFileTime = false
        }
      )
    },
    deleteTeacher(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteTeacher({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')

            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === row.id) {
                this.tableData.splice(i, 1)
              }
            }
          }
        })
      })
    },

    //重置校区信息
    resetHomepage(type) {
      this.$confirm('确定重置师资力量吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resetHomepage({
          reset_type: type,
        }).then((res) => {
          console.log('重置信息')
          console.log(res)
          if (res.is_update) {
            this.$message.success('重置成功,请刷新本页面')
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.addcourses {
  margin-top: 20px;
}

.form {
  margin-top: 20px;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>
